import { render, staticRenderFns } from "./MonitorTags.vue?vue&type=template&id=21f2ca9a&"
import script from "./MonitorTags.vue?vue&type=script&lang=js&"
export * from "./MonitorTags.vue?vue&type=script&lang=js&"
import style0 from "./MonitorTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports